import { Component, OnInit } from '@angular/core';
import { Profile } from '../../profile/shared/profile';
import { ProfileService } from '../../profile/shared/profile.service';
import * as moment from "moment";

@Component({
  selector: 'app-context',
  templateUrl: './context.component.html',
  styleUrls: ['./context.component.scss']
})
export class ContextComponent implements OnInit {

  profile: Profile;

  constructor(
    private profileService: ProfileService) { }

  ngOnInit() {
    this.profileService.getProfileOfCurrentUser().subscribe(profile => this.profile = profile);
  }

  getCurrentDate(): string{
    return moment().locale('fr').format('LL');
  }
}
